import React from 'react';
import { Checkbox } from '@material-ui/core';
import { RatePlanProperty, RoomRatePlan } from 'app/state';

// Lets staff enable or disable the meal-plan amenity per additional property, independent of the main plan.
export function MealPlanAvailabilityColumn(
  isAvailable: (plan: RoomRatePlan) => boolean,
  onChange: (plan: RoomRatePlan, available: boolean) => void
) {
  return [
    {
      title: 'Meal Plan',
      align: 'center' as const,
      colSpan: 1,
      valueFactory: (plan: RoomRatePlan) => (
        <Checkbox
          checked={isAvailable(plan)}
          onChange={e => onChange(plan, e.target.checked)}
          onClick={e => e.stopPropagation()}
          inputProps={{
            'aria-label': `Meal plan available for ${(plan as RatePlanProperty).propertyName}`,
          }}
          data-testid="ratePlanRowMealPlanAvailableCheckbox"
        />
      ),
    },
  ];
}
